// extracted by mini-css-extract-plugin
module.exports = {"SectionText":"SectionText_SectionText__2CYx9"};